import { LineChart } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { ExecutivePage } from './pages/ExecutivePage'

/**
 * Executive Overview (Sprint 13b — Phase 3 sidebar restructure).
 *
 * First module in the new `'executive'` section. Surfaces the eight
 * KPIs from `enhancement-01-sidebar-sectioning.md` §Executive
 * dashboard scope. Five wired against live endpoints
 * (revenue MTD, cash position, low stock, open RFQs, margin trend);
 * three rendered as placeholders (P&L, pending invoices, AR/AP ratio)
 * pending the Finance modules in a future sprint.
 *
 * RBAC: visibility limited to admin + finance (per spec D-2 — Finance
 * section gains its own modules later but doesn't duplicate Margins).
 * Other roles don't see the module or its section in the sidebar.
 */
export default defineModule({
  id: 'executive',
  name: 'Executive Overview',
  shortName: 'Executive',
  icon: LineChart,
  navSection: 'executive',
  navOrder: 10,
  urlNamespace: '/executive',
  routes: [{ path: '/', element: ExecutivePage, label: 'Overview' }],
  permissions: ['admin', 'finance'],
  densityDefault: 'comfortable',
  mobileStrategy: 'responsive',

  keyboardShortcut: 'g e',

  commandPaletteEntries: [
    {
      label: 'Go to Executive Overview',
      keywords: [
        'executive',
        'overview',
        'kpi',
        'revenue',
        'cash',
        'pnl',
        'finance',
        'cfo',
      ],
      path: '/',
      group: 'modules',
      shortcut: 'g e',
    },
  ],
})
